import * as React from 'react';
import Grid from '@mui/material/Grid';
import GitHubIcon from '@mui/icons-material/GitHub';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import MainFeaturedPost from './MainFeaturedPost';
import FeaturedPost from './FeaturedPost';
import Main from './Main';
import Sidebar from './Sidebar';
import { getAllBlogs, getBlogs, getHeaderBlogs, getTopBlogs } from './core/Apis';
import Loading from './core/Loading';
import { checkText, strip } from './core/Helpers';
import { Helmet } from 'react-helmet';



export default function Blog(props) {
  const [loading, setLoading] = React.useState(true)
  const [mainFeaturedPost, setmainFeaturedPost] = React.useState({});
  const [featuredposts, setfeaturedposts] = React.useState([]);
  const [sidebar, setsidebar] = React.useState({});
  const [posts, setposts] = React.useState([])
  const [limit, setLimit] = React.useState(10)
  const [offset, setoffset] = React.useState(0)
  const postsResults = async (x) => {
    let postsFeature = [];
    // change links to Link word with hover
    await x?.forEach(async (element, xds) => {
      postsFeature.push({
        title: await checkText(strip(element.title).substring(0, 100) + (element.title.length > 100 ? '...' : '')),
        date: (new Date(element.updated_at || '')).toLocaleDateString(),
        link: `/v2/article/${element.path}`,
        description: await checkText(strip(element.body).substring(0, 100) + (element.body.length > 100 ? '...' : '')),
        image: element.image,
        author: element.author?.firstname ? element.author.firstname + ' ' + element.author.lastname : ' ',
        categories: element.categories?.length > 0 ? element.categories[0].category : '',
        imageLabel: element.title,
        imageText: element.title,
      })
    });
    return postsFeature;
  }
  const viewsResults = async (x) => {
    // change links to Link word with hover
    if (x?.length > 0) {
      const newPosts = x?.map(async (element, xds) => {
        return {
          title: checkText(strip(element.post?.title).substring(0, 100) + (element.post?.title.length > 100 ? '...' : '')),
          date: (new Date(element.post?.updated_at || '')).toLocaleDateString(),
          link: `/v2/article/${element.post?.path}`,
          description: checkText(strip(element.post?.body).substring(0, 200) + (element.post?.body.length > 200 ? '...' : '')),
          image: element.post?.image,
          author: element.post?.firstname ? element.post?.firstname + ' ' + element.post?.lastname : ' ',
          categories: '',
          imageLabel: element.post?.title,
          imageText: element.post?.title,
        }
      });
      const newTitle = await checkText(strip(x[0].post?.title).substring(0, 100) + (x[0].post?.length > 100 ? '...' : ''));
      const newDesc = await checkText(strip(x[0].post?.body).substring(0, 200) + (x[0].post?.body.length > 200 ? '...' : ''));
      const sidebar = {
        title: newTitle,
        description: newDesc,
        archives: newPosts,
        social: [
          { name: 'GitHub', icon: GitHubIcon },
          { name: 'Twitter', icon: TwitterIcon },
          { name: 'Facebook', icon: FacebookIcon },
        ],
      }
      return sidebar;
    }
  }
  // Update all
  React.useEffect(() => {
    getHeaderBlogs().then(async x => {
      return setmainFeaturedPost({
        title: await checkText(strip(x[0].title).substring(0, 100) + (x[0].title.length > 100 ? '...' : '')),
        description: await checkText(strip(x[0].body).substring(0, 100) + (x[0].body.length > 100 ? '...' : '')),
        image: x[0].image,
        author: x[0].author.firstname + ' ' + x[0].author.lastname,
        categories: x[0].categories?.length > 0 ? x[0].categories[0].category : '',
        imageText: x[0].title,
        imageLabel: x[0].title,
        link: `/v2/article/${x[0].path}`,
        linkText: x[0].title,
      })
    })
    // featured
    getAllBlogs().then(async x => {
      return setfeaturedposts(await postsResults(x))
    }
    )
    getBlogs().then(async x => {
      return setposts(await postsResults(x))
    }
    )
    getTopBlogs().then(async x => {
      const final = await viewsResults(x);
      return final;
    }
    ).then(data => {
      return setsidebar(data);
    })
    setTimeout(() => {
      setLoading(false)
    }, 3000);
  }, [])

  if (loading || posts?.length === 0) {
    return (<>
      <Loading width={"100%"} />
    </>)
  }
  return (<>
    <MainFeaturedPost post={mainFeaturedPost} />
    <Grid container spacing={4}>
      {featuredposts?.length > 0 && featuredposts?.map((post, xds) => {
        return <FeaturedPost key={xds} post={post} />
       })}

    </Grid>

    <Grid container spacing={5} sx={{ mt: 3 }}>
      {posts?.length > 0 && <Main title="Recent Articles" posts={posts} />}
      <Sidebar
        title={sidebar?.title}
        description={sidebar?.description}
        archives={sidebar?.archives}
        social={sidebar?.social}
      />
    </Grid>
    <button onClick={() => getBlogs(limit, offset + 10).then(async x => {
      setoffset(offset + 10);
      const newList = await postsResults(x);
      return setposts(posts?.concat(newList))
    }
    )} className="btn btn-primary center" >Show More</button>
  </>
  );
}
